import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { useFormik } from 'formik';
import Select from "react-select";
import { getHrmsBranchList } from "../../../Redux/action/Organisation/Branch/BranchAction";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "js-cookie";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { BeatLoader } from 'react-spinners';
import Skeleton from 'react-loading-skeleton'
import { Table } from "antd";
import { adminMainUrl } from "../../../Config";
import { getVehicleList, getTransporterList } from "../../../Redux/action/Transport/TransportAction";
import ReactPaginate from 'react-paginate';

const VehicleList = ({ accessedModules, accessedPermission }) => {
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [dataOffset, setDataOffset] = useState(0);
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);

    const dataPerPage = 10;
    const [reload, setReload] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(false)
    const [RequiredServiceName, setRequiredServiceName] = useState(null);
    const [RequiredServiceId, setRequiredServiceId] = useState(null);
    const navigate = useNavigate();
    const flexichain_user_id = Cookies.get('flexichain_user_id')
    const token = Cookies.get('token')

    const handleEditShow = (id) => {
        navigate(`/flexichain/transport-vehicle-edit/${btoa(id)}`)
    };
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const currentPage = parseInt(queryParams.get('page')) || 1;

    const dispatch = useDispatch();
    const {
        loadingVehicleList,
        VehicleListError,
        VehicleList,
        VehicleListCurrentPage,
        VehicleListTotalData,
        VehicleListPerPageData,
        VehicleListTotalPages,
    } = useSelector(state => state?.TransportReducer);

    const handlePageClick = (event) => {
        const selectedPage = event.selected + 1;
        const params = new URLSearchParams(location.search);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };

    let { HrmsBranchList } = useSelector(state => state?.BranchReducer);
    const branchList = HrmsBranchList && Array.isArray(HrmsBranchList) ? HrmsBranchList.map((item) => ({
        value: item.branch_id,
        label: item.branch_name,
    })) : [];

    let { sidebarPermissionHRMSData } = useSelector(state => state?.NavbarReducer);
    const hasFilterPermission = sidebarPermissionHRMSData?.role_id == sidebarPermissionHRMSData?.user_id;

    const formik = useFormik({
        initialValues: {
            vehicle_id: queryParams.get("vehicle_id") || "",
            vehicle_type: queryParams.get("vehicle_type") || "",
            branch_id: queryParams.get("branch_id") || "",
        },
        onSubmit: (values) => {
            const params = new URLSearchParams();
            Object.keys(values).forEach(key => {
                if (values[key]) {
                    params.append(key, values[key]);
                }
            });
            params.set("page", 1);
            navigate(`?${params.toString()}`);
        },
    });

    const resetFilters = () => {
        formik.resetForm();
        navigate(`?page=1`);
    };

    useEffect(() => {
        dispatch(getHrmsBranchList(token, flexichain_user_id));
    }, []);

    useEffect(() => {
        const queryParamsString = location.search.substring(1);
        dispatch(getVehicleList(token, flexichain_user_id, currentPage, queryParamsString));
    }, [location.search, reload, adminMainUrl]);


    const handleSuccess = () => {
        // Toggle reload to trigger useEffect
        setReload((prev) => !prev);
    };

    // Initialize Formik
    const statusChange = async (id) => {
        setSpinnerLoader(true)
        try {

            const response = await fetch(`${adminMainUrl}/api/transport/vehicle/status`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': Cookies.get('token'), 'user_id': Cookies.get('flexichain_user_id'), // Assuming token is stored in cookies
                },
                body: JSON.stringify({ id: id.toString() }),
            });

            const data = await response.json();

            if (response.ok) {
                setSpinnerLoader(false)
                handleSuccess(); // Call the success handler
                toast.success(data?.msg);
            } else {
                setSpinnerLoader(false)
                toast.error(data?.msg);
            }
        } catch (error) {
            setSpinnerLoader(false)
            console.error('Network error:', error);
        }
    };
    const handleChange = (id) => {
        // if (accessedPermission.includes("state_change_master_data")) {
        statusChange(id);
        // }
    };
    const [grid, setGrid] = useState(true)
    const arr = new Array(5).fill(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }
    // const columns = [
    //     { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
    //     { title: "Date", dataIndex: "date", key: "date" },
    //     { title: "Name", dataIndex: "name", key: "name" },
    //     { title: "Email", dataIndex: "email", key: "email" },
    //     { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
    //     { title: "Origin", dataIndex: "origin", key: "origin" },
    //     { title: "Destination", dataIndex: "destination", key: "destination" },
    //     { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
    //     { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
    //     { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
    //     { title: "Action", dataIndex: "action", key: "action" },
    // ];
    const currentItems = VehicleList;
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },

        { title: "Vehicle ID", dataIndex: "vehicleId", key: "vehicleId" },
        { title: "Vehicle Type", dataIndex: "vehicleType", key: "vehicleType" },

        { title: "Status", dataIndex: "Status", key: "Status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    console.log(VehicleList)

    const dataSource = VehicleList?.map((value, i) => ({
        key: i, // Add a unique key for each row
        SNo: ((currentPage - 1) * 10) + i + 1, // Changed to account for pagination

        vehicleId: value?.vehicle_id,

        vehicleType: value?.vehicle_type,


        Status:
            <>
                <span id={`flexSwitchCheckChecked-${i}`}
                    onClick={() => handleChange(value.id)} className={`cursor-pointer ${value.status === true ? "badge badge-pill badge-status bg-success" : "badge badge-pill badge-status bg-danger"}  `}>{value.status === true ? "Active" : "Inactive"}</span>

                {/* <div className="form-check form-switch d-flex justify-content-center">
            <div
                type="button"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title={value.status === true ? "active" : "inactive"}
            >
                <input
                    className="form-check-input"
                    type="checkbox"
                    id={`flexSwitchCheckChecked-${i}`}
                    checked={value.status === true}
                    onChange={() => handleChange(value.id)}
                />
            </div>
        </div> */}
            </>
        ,
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className=" cursor-pointer" onClick={() => {
                        handleEditShow(value?.id);

                    }}>
                        <i className="ti ti-edit text-blue"></i> Edit
                    </div>
                    {/* <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_contact">
                        <i className="ti ti-trash text-danger"></i> Delete
                    </Link> */}
                    {/* <div className="dropdown-item" onClick={() => { navigate('/flexichain/view-price-information', { state: { quotationId: value.id } }) }}>
                        <i className="ti ti-eye text-blue-light"></i> Preview
                    </div> */}
                </div>
            </div>
        ),
    }));



    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Vehicle List<span className="count-title">{VehicleListTotalData ? VehicleListTotalData : 0}</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">

                        <form onSubmit={formik.handleSubmit}>
                            <div className="card-header py-2">
                                <div className="row align-items-center">
                                    <div className="col-sm-4">
                                        <div className="icon-form mb-3 mb-sm-0">
                                            <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Search Vehicle ID"
                                                name='vehicle_id'
                                                value={formik.values.vehicle_id}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                            <button type='submit' className="btn btn-primary me-2">
                                                Search
                                            </button>
                                            <a
                                                className='btn btn-primary me-2'
                                                onClick={() => { resetFilters() }}
                                            >
                                                Clear
                                            </a>
                                            <Link to="/flexichain/transport-vehicle-form" className="btn btn-primary">
                                                <i className="ti ti-square-rounded-plus me-2" />
                                                Add Vehicle
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body py-2">
                                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    </div>
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                        <div className="form-sorts dropdown me-2">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="dropdown"
                                                data-bs-auto-close="outside"
                                            >
                                                <i className="ti ti-filter-share" />
                                                Filter
                                            </a>
                                            <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                                                <div className="filter-set-view">
                                                    <div className="filter-set-head">
                                                        <h4>
                                                            <i className="ti ti-filter-share" />
                                                            Filter
                                                        </h4>
                                                    </div>
                                                    <table className="content-table">
                                                        <tbody>
                                                            <tr>
                                                                <td><label>TYPE</label></td>
                                                                <td className="input_box_filter">
                                                                    <input type="text" className="form-control form-control-sm ms-2" placeholder="Enter Type" name="vehicle_type" value={formik.values.vehicle_type} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                                                                </td>
                                                            </tr>
                                                            {hasFilterPermission && (
                                                                <tr>
                                                                    <td><label>BRANCH</label></td>
                                                                    <td className="input_box_filter">
                                                                        <Select
                                                                            className="ms-2"
                                                                            classNamePrefix="react-select"
                                                                            placeholder="Select Branch"
                                                                            options={branchList}
                                                                            isClearable
                                                                            styles={{
                                                                                container: (base) => ({ ...base, width: '100%' }),
                                                                                control: (base) => ({ ...base, minHeight: '33px', height: '32px', fontSize: '12px' }),
                                                                                valueContainer: (base) => ({ ...base, height: '32px', padding: '0 6px' }),
                                                                                indicatorsContainer: (base) => ({ ...base, height: '32px' }),
                                                                                menu: (base) => ({ ...base, fontSize: '12px' }),
                                                                                option: (base) => ({ ...base, fontSize: '12px', padding: '4px 8px' }),
                                                                            }}
                                                                            value={branchList.find(opt => opt.value === formik.values.branch_id) || null}
                                                                            onChange={(selected) => formik.setFieldValue("branch_id", selected ? selected.value : "")}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                    <div className="filter-reset-btns">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <a href="javascript:void(0);" className="btn btn-light w-100" onClick={resetFilters}>Reset</a>
                                                            </div>
                                                            <div className="col-6">
                                                                <button type="submit" className="btn btn-primary w-100">Filter</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /Filter */}
                                {/* Contact List */}
                                {
                                    loadingVehicleList ?
                                        arr.map((value, index) => {
                                            return (

                                                <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                                    <BeatLoader />
                                                </div>
                                            )
                                        }) :
                                        spinnerLoader ?
                                            <>
                                                <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                                    <BeatLoader />
                                                </div>
                                            </> :
                                            <>
                                                <div className="table-responsive custom-table">
                                                    <Table className="table datanew dataTable no-footer" pagination={false}
                                                        dataSource={dataSource} columns={columns} />
                                                </div>

                                                {VehicleList?.length > 0 && <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                    <ReactPaginate
                                                        previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                        nextLabel={<img src="/img/left.png" alt="Next" />}
                                                        breakLabel="..."
                                                        breakClassName="break-me"
                                                        pageCount={VehicleListTotalPages || 1}
                                                        marginPagesDisplayed={2}
                                                        pageRangeDisplayed={5}
                                                        onPageChange={handlePageClick}
                                                        containerClassName="pagination"
                                                        activeClassName="active"
                                                        forcePage={currentPage - 1}
                                                    />
                                                </div>}
                                            </>
                                }

                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </>

    )
}

export default VehicleList